import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { SavedSearchesService } from '../../../../misc/saved-searches/services/saved-searches.service';
import { takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Severity } from 'src/app/inventory/constants/constants';
import { TitleCasePipe } from '@angular/common';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ChatBotModule, IEmailMessageRequest, IFeedbackModel, IInitializeModel, InitializeWorkspaceDataModel, IQuestionModel, typeChatBotModule } from './model/chatbot.model';
import { AppShortenFilter } from 'src/app/modules/shared/pipes/shorten.filter';
// import { ApexAxisChartSeries, ApexChart, ApexYAxis, ApexXAxis } from "ng-apexcharts";
import { FinanceService } from 'src/app/finance/finance.service';
import { DashboardService } from '../../../../profile/dashboard/services/dashboard.service';
import { DashboardViewContentWidgetModels, DashboardViewContentsModels, DashboardViewDetailsModels, DashboardViewLayoutDetailsModels } from '../../../../profile/dashboard/models/dashboard-view-details.models';
import { DashboardAddLayoutModels } from '../../../../profile/dashboard/models/dashboard-add-layoutdetails.models';
import { DashboardAddChannelModels } from '../../../../profile/dashboard/models/dashboard-add-channel.models';
import { DashboardWidgetViewListModels } from '../../../../profile/dashboard/models/dashboard-widget-view-list.models';
import { DashboardContentChartTypes, typeDashboardContentChartTypes } from '../../../../profile/dashboard/models/dashboard-content-items.models';
import { LeadReportsFiltersModels } from 'src/app/models/lead-reports/lead-reports-filters.models';
import { reportsSecondLevelMenuData } from 'src/app/reports/reports-menu.data';
import { ObjectNames } from '../../constants/object.names';
import { DashboardAddContentFiltersModels, DashboardAvailableFilterTypes } from '../../../../profile/dashboard/models/dashboard-add-content-filters.models';
import { DashboardWidgetListModels } from '../../../../profile/dashboard/models/dashboard-widget-list.models';
import { getDateRange } from '../../helpers/get-date-range.helper';
import { GetDateRangeType } from 'src/app/models/date-range/get-date-range.models';
import { DashboardMasterAttributes } from '../../../../profile/dashboard/models/dashboard-master-attributes';
import { DashboardAddContentModels } from '../../../../profile/dashboard/models/dashboard-add-content.models';
import { EmailAddress } from '../../model/models';
import { EmailService } from '../shared-emails/email.service';
import { SendEmailService } from '../send-email/send-email.service';
import { DynamicTableService } from '../../services/dynamic-table/dynamic-table.service';
import { TimeZoneService } from '../../services/timezone.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-chatbot-modal',
    templateUrl: './chatbot-modal.component.html',
    styleUrls: ['./chatbot-modal.component.scss'],
    providers: [AppShortenFilter]
})
export class ChatBotModalComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
    @Input() display: boolean = false;
    @Input() chatBotInitializationData: any;
    @Output() onCancel = new EventEmitter<any>();
    @Input() moduleName: typeChatBotModule;
    @Input() chatbotModules;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @ViewChild('container') container;
    // @ViewChild('chatListContainer') list?: ElementRef<HTMLDivElement>;
    @ViewChild('scroll') private scrollContainer: ElementRef;

    /** Table Variables */
    pageSize: number = 5;

    sessionId;
    title = 'chat-ui';
    chatInputMessage: string = "";
    sender = {
        id: 1,
        profileImageUrl: 'https://cdn.pixabay.com/photo/2017/07/18/23/23/user-2517433_960_720.png'
    }

    receiver = {
        id: 2,
        profileImageUrl: 'https://cdn.pixabay.com/photo/2017/07/18/23/23/user-2517433_960_720.png'
    }

    chatMessages: {
        user: any,
        message: any,
        messageSegments?: string[],
        image: any,
        messageType: string,
        queryId: number,
        query: string,
        table?: any,
    }[] = [
            {
                user: this.receiver,
                image: "",
                message: "Hello, I am an AI assistant, you can ask me anything related to the dataset",
                messageType: "text",
                queryId: 0,
                query: ""
            },
        ];
    showEmojiPicker = false;
    sets = [
        'native',
        'google',
        'twitter',
        'facebook',
        'emojione',
        'apple',
        'messenger'
    ]
    set = 'twitter';
    suggestions = [
        {
            id: 1,
            name: "Recent results",
            children: []
        },
        {
            id: 2,
            name: "Suggestions",
            children: []
        }
    ];
    expandedRows: {} = {};
    showSpinner = false;
    currentDate = this.app._showDateTimeWithZone(new Date());

    displayFeedback = false;
    isMini = false;
    scrHeight: any;
    displayChart = false;
    chartHeader;
    chartType;
    chartData;
    selectedChartData: any;

    feedbackText: string = "";
    feedback: boolean = false;
    queryId: number = 0;

    @ViewChild('content') elementView: ElementRef;
    contentHeight;
    funnelChartContentHeight = 400;

    dashboardChannels = [];
    displayNewLayout = false;
    selectedDasboardChannel: any;
    dashboardDetails: any[] = [];
    widgetsTypes = [
        {
            id: 1,
            name: "Main Widgets"
        },
        {
            id: 2,
            name: "Summary Widgets"
        }
    ];

    numberOfWidgets: number[] = [1, 2, 3];
    selectedNumberOfWidgets: number = 1;

    selectedWidgetType: any = this.widgetsTypes[0].id;
    addedDashboardChannel: any;
    channelSelectErrorMsg: string = "";
    savedToDashboardTitleErrorMsg: string = "";
    dashboardList: DashboardWidgetViewListModels[] = [];
    reportPermissionData: any[] = [];
    userPermissionData: any[] = [];
    reportsAllMenus = reportsSecondLevelMenuData();
    // dashboardTempId: number = -1;
    savedToDashboardTitle: string = '';

    //email
    displayEmail = false;
    toRecipients: EmailAddress[] = [];
    emailList: EmailAddress[] = [];
    emailListCopy: EmailAddress[] = [];
    allRecipients: EmailAddress[] = [];
    sendMailLoading: boolean = false;

    configMenu;

    constructor(
        public app: AppMainComponent,
        private savedSearchesService: SavedSearchesService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        public appMainService: AppMainService,
        private shortenPipe: AppShortenFilter,
        private confirmationService: ConfirmationService,
        private financeService: FinanceService,
        private dashboardService: DashboardService,
        private emailService: EmailService,
        private sendEmailSevice: SendEmailService,
        private dynamicTableService: DynamicTableService,
        private timeZoneService: TimeZoneService
    ) {
        this.getScreenSize();
    }

    ngOnInit(): void {
        this.onBodyHidden();
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.buildMenu();

        if (changes.chatBotInitializationData && changes.chatBotInitializationData.currentValue) {
            this.chatBotInitializationData = changes.chatBotInitializationData.currentValue;
            if (this.chatBotInitializationData && this.chatBotInitializationData.sessionId) {
                this.sessionId = this.chatBotInitializationData.sessionId;
                this.getSampleQuestions(this.sessionId);
            } else {
                this.initialize(this.chatBotInitializationData);
            }
        }
        if ((changes.moduleName?.currentValue !== changes.moduleName?.previousValue) && (changes.moduleName?.previousValue) && (this.moduleName !== ChatBotModule.SavedSearch)) {
            this.onMaximize();
        }
    }
    buildMenu() {
        let savedsearch = this.app.selectedChatbotWindow == ChatBotModule.SavedSearch ? '<span class="selectedConfigMenuItem">Saved Search</span>' : 'Saved Search';
        let finance = this.app.selectedChatbotWindow == ChatBotModule.Journal ? '<span class="selectedConfigMenuItem">Finance</span>' : 'Finance';

        this.configMenu = [
            {
                label: savedsearch,
                escape: false,
                visible: this.chatbotModules.indexOf(ChatBotModule.SavedSearch) > -1,
                command: () => {
                    this.app.selectedChatbotWindow == ChatBotModule.SavedSearch;
                    this.buildMenu();
                }
            },
            {
                label: finance,
                escape: false,
                visible: this.chatbotModules.indexOf(ChatBotModule.Journal) > -1,
                command: () => {
                    this.app.selectedChatbotWindow == ChatBotModule.Journal;
                    this.buildMenu();
                }
            },
        ]
    }
    ngAfterViewInit() {
        this.contentHeight = this.elementView.nativeElement.offsetHeight - 150 + 'px';
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    getScreenSize(event?) {
        if (window.innerHeight <= 900) {
            this.scrHeight = window.innerHeight - 390 + "px";
        } else {
            this.scrHeight = window.innerHeight - 550 + "px";
        }
    }
    initialize(chatBotInitializationData) {
        if (this.moduleName == ChatBotModule.Journal) {
            this.showSpinner = true;
            const sessionData = localStorage.getItem('liono360') ? this.app.decode(localStorage.getItem('liono360')) : null;
            const timeZoneData = sessionData.timeZone;
            this.financeService.journalInitialize(chatBotInitializationData?.fromDate, chatBotInitializationData?.toDate, timeZoneData?.isDayLight, chatBotInitializationData?.fiscalYearStartingMonth, chatBotInitializationData?.fiscalYearEndingMonth)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        this.sessionId = response?.sessionId;
                        this.chatBotInitializationData.sessionId = response?.sessionId;
                        this.showSpinner = false;
                        // this.getSampleQuestions(this.sessionId);
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                });
        }
        else if (this.moduleName == ChatBotModule.SavedSearch) {

            let initializationData: IInitializeModel = {
                savedSearchId: chatBotInitializationData?.selectedSearch?.id ?? 0,
                savedSearchName: this.removeSpecialCharacters(chatBotInitializationData?.selectedSearch?.name)
            }
            this.showSpinner = true;
            this.savedSearchesService.initialize(initializationData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        this.sessionId = response?.sessionId;
                        this.chatBotInitializationData.sessionId = response?.sessionId;
                        this.showSpinner = false;
                        this.getSampleQuestions(this.sessionId);
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                });
        }
        else if (this.moduleName == ChatBotModule.WorkBook) {
            let initializationData: InitializeWorkspaceDataModel = {
                workBookId: chatBotInitializationData?.workbookId ?? 0,
                workBookName: this.removeSpecialCharacters(chatBotInitializationData?.selectedWorkbook?.name)
            }

            this.showSpinner = true;
            this.dynamicTableService.initialize(initializationData?.workBookId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        this.sessionId = response?.key;
                        this.chatBotInitializationData.sessionId = this.sessionId;
                        this.showSpinner = false;
                        this.getSampleQuestions(this.sessionId);
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                })
        }
    }


    getSampleQuestions(sessionId) {
        if (this.moduleName == ChatBotModule.Journal) {

        }
        else if (this.moduleName == ChatBotModule.SavedSearch) {
            this.showSpinner = true;
            this.savedSearchesService.getSampleQuestions(sessionId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (secondApiResponse) => {
                        let questions = secondApiResponse?.questions?.map((item, index) => {
                            this.expandedRows[index + 1] = true;
                            return { id: index + 1, name: item }
                        });
                        this.suggestions[1].children = questions ?? [];
                        this.showSpinner = false;
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                });
        }
        else if (this.moduleName == ChatBotModule.WorkBook) {
            this.showSpinner = true;
            this.dynamicTableService.getSampleQuestion(sessionId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (secondApiResponse) => {
                        let questions = secondApiResponse?.questions?.map((item, index) => {
                            this.expandedRows[index + 1] = true;
                            return { id: index + 1, name: item }
                        });
                        this.suggestions[1].children = questions ?? [];
                        this.showSpinner = false;
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                })
        }
    }


    send() {
        this.suggestions[0].children.push({ name: this.chatInputMessage });
        this.chatMessages.push({
            message: this.chatInputMessage,
            image: "",
            user: this.sender,
            messageType: "text",
            queryId: 0,
            query: ""
        });
        this.chatMessages.push({
            message: "",
            image: "",
            user: this.receiver,
            messageType: "typing",
            queryId: 0,
            query: ""
        });

        let questionData: IQuestionModel = {
            question: this.chatInputMessage?.trim(),
            sessionId: this.sessionId,
            ianatimezone: this.timeZoneService.getUserIANATimeZone()
        }
        if (this.moduleName == ChatBotModule.Journal) {
            this.financeService.journalAskQuestion(questionData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (res) => {
                        if (res) {
                            this.removeTypingIndicatorMessage();
                            this.prepareResponseMessage(res, questionData.question);
                        }
                        setTimeout(() => this.scrollToBottom(), 100);
                    },
                    error: (error) => {
                        this.removeTypingIndicatorMessage();
                        this.chatMessages.push({
                            message: "Couldn't process your request !!!",
                            image: "",
                            user: this.receiver,
                            messageType: "text",
                            queryId: 0,
                            query: ""
                        });
                    }
                });
        }
        else if (this.moduleName == ChatBotModule.SavedSearch) {
            this.savedSearchesService.askQuestion(questionData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (res) => {
                        if (res) {
                            this.removeTypingIndicatorMessage();
                            this.prepareResponseMessage(res, questionData.question);
                        }
                        setTimeout(() => this.scrollToBottom(), 100);
                    },
                    error: (error) => {
                        this.removeTypingIndicatorMessage();
                        this.chatMessages.push({
                            message: "Couldn't process your request !!!",
                            image: "",
                            user: this.receiver,
                            messageType: "text",
                            queryId: 0,
                            query: ""
                        });
                    }
                });
        }
        else if (this.moduleName == ChatBotModule.WorkBook) {
            let questionData: any = {
                user_query: this.chatInputMessage?.trim(),
                key: this.sessionId
            }
            this.dynamicTableService.askQuestions(questionData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (res) => {
                        if (res) {
                            this.removeTypingIndicatorMessage();
                            this.prepareResponseMessage(res, questionData.question);
                        }
                        setTimeout(() => this.scrollToBottom(), 100);
                    },
                    error: (error) => {
                        this.removeTypingIndicatorMessage();
                        this.chatMessages.push({
                            message: "Couldn't process your request !!!",
                            image: "",
                            user: this.receiver,
                            messageType: "text",
                            queryId: 0,
                            query: ""
                        });
                    }
                })
        }

        this.chatInputMessage = "";
    }
    // prepareResponseMessage(res, query){
    //     if(res.response.hasOwnProperty('table')){
    //         this.chatMessages.push({
    //             message: res.response.table ?? "",
    //             user: this.receiver,
    //             messageType: "table",
    //             queryId: res?.queryId ?? 0,
    //             query: query
    //         });
    //     }
    //     else if(res.response.hasOwnProperty('pie')){
    //         this.preparePieChartData(res, query);
    //     }
    //     else if(res.response.hasOwnProperty('bar')){
    //         this.prepareBarChartData(res, query);
    //     }
    //     else if(res.response.hasOwnProperty('line')){
    //         this.prepareLineChartData(res, query);
    //     }
    //     else if(res.response.hasOwnProperty('donut')){
    //         this.prepareDonutChartData(res, query);
    //     }
    //     else if(res.response.hasOwnProperty('funnel')){
    //         this.prepareFunnelChartData(res, query);
    //     }else if(res.response.hasOwnProperty('scatter')){
    //         this.prepareScatterChartData(res, query);
    //     }
    //     else {
    //         this.chatMessages.push({
    //             message: res.response.answer ?? "",
    //             user: this.receiver,
    //             messageType: "text",
    //             queryId: res?.queryId ?? 0,
    //             query: query
    //         });
    //     }
    // }
    prepareResponseMessage(res, query) {
        if (res.figure) {
            this.chatMessages.push({
                message: res.output,
                image: res.figure ? this.preparePlotlyConfig(res.figure) : "",
                user: this.receiver,
                messageType: "image",
                queryId: res?.queryId ?? 0,
                query: query
            });
        }
        else if (res.table) {
            this.chatMessages.push({
                message: res.output,
                image: "",
                user: this.receiver,
                messageType: "table",
                queryId: res?.queryId ?? 0,
                query: query,
                table: this.processData(res.table)
            });
        }
        else {
            this.chatMessages.push({
                message: res.output,
                messageSegments: this.generateMessageSegments(res.output),
                image: "",
                user: this.receiver,
                messageType: "text",
                queryId: res?.queryId ?? 0,
                query: query
            });
        }
    }

    isTotalRow(headers: string[], row: any): boolean {
        return headers.some(header => (row[header] || '').toString().toLowerCase().includes('total'))
    }

    generateMessageSegments(rawText: string) {
        const segments = [];
        const regex = /csv_start([\s\S]*?)csv_end/g; //split tables from text
        let lastIndex = 0;
        let match: RegExpExecArray | null;

        while ((match = regex.exec(rawText)) !== null) {
            // Push preceding text
            if (match.index > lastIndex) {
                const text = rawText.slice(lastIndex, match.index).trim();
                segments.push({ type: 'text', content: text });
            }

             // Parse CSV
             const csvBlock = match[1].trim();
             const lines = csvBlock.split('\n').map(line => line.trim());
             const headers = parseCSVLine(lines[0]);
             const rows = lines.slice(1).map(line => {
                 const values = parseCSVLine(line);
                 const row: any = {};
                 headers.forEach((header, i) => {
                     row[header] = values[i];
                 });
                 return row;
             });

             segments.push({ type: 'table', content: rows, headers });
             lastIndex = regex.lastIndex;
        }

        function parseCSVLine(line: string): string[] {
            return line.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)?.map(v => v.replace(/^"|"$/g, '')) || [];
        }

        // Push remaining text after last CSV
        if (lastIndex < rawText.length) {
            const text = rawText.slice(lastIndex).trim();
            segments.push({ type: 'text', content: text });
        }

        return segments;
    }

    //#region plotly config Logic
    preparePlotlyConfig(res: any) {
        let chartResponse = JSON.parse(res);
        let { data, layout } = chartResponse;

        let config = {
            modeBarButtonsToAdd: [{
                name: 'Pin',
                icon: {
                    width: 1000,
                    height: 1000,
                    // The SVG path from your icon, scaled and adjusted
                    path: 'M684 898 c-36 -34 -42 -54 -31 -98 5 -22 -3 -31 -72 -82 -78 -57 -79 -58 -126 -49 -56 10 -145 -5 -195 -35 -47 -27 -50 -63 -10 -129 16 -27 41 -64 54 -80 l25 -30 -104 -115 c-105 -116 -145 -173 -132 -187 14 -14 74 28 188 132 l114 104 30 -25 c60 -49 129 -84 160 -82 24 2 35 12 55 48 22 39 25 58 26 143 l1 98 54 74 c48 65 57 73 79 68 14 -4 34 -6 45 -5 26 1 85 66 85 92 0 71 -119 190 -190 190 -11 0 -36 -15 -56 -32z M788 896 c31 -17 94 -81 111 -113 15 -30 14 -58 -3 -72 -12 -10 -16 -6 -21 20 -10 43 -101 134 -144 144 -26 5 -30 9 -20 21 15 18 43 18 77 0z M750 720 c0 -27 -51 -102 -98 -144 -21 -18 -22 -18 -46 11 -13 16 -36 35 -50 42 -14 8 -26 17 -26 21 0 3 42 37 92 74 l93 68 17 -22 c10 -12 18 -35 18 -50z M517 628 c24 -11 59 -38 78 -61 31 -36 35 -47 35 -99 0 -32 -7 -75 -15 -95 l-16 -37 -21 34 c-32 54 -177 192 -237 227 l-54 31 34 10 c78 25 128 22 196 -10z M427 414 c7 -19 -18 -45 -162 -176 -99 -90 -145 -126 -145 -115 0 21 267 307 286 307 8 0 17 -7 21 -16z',
                    transform: 'matrix(1 0 0 -1 0 1000)', // This flips the icon vertically since SVG coordinate system is different
                    fillcolor: '#000000',
                    ascent: 1000,
                    descent: 0
                },
                click: (newVar: any) => {
                    window.alert('Custom button clicked!');
                }
            }],
            modeBarButtonsToRemove: ['displaylogo'],
            displaylogo: false
        };

        return { data, layout, config };
    }

    //#end region

    processData(rawData) {
        try {
            const parsedData = JSON.parse(rawData);
            let columns: { field: string, header: string }[] = []
            columns = Object.keys(parsedData).map(key => ({
                field: key,
                header: key,
            }));
            let tableData: any[] = []
            const rowCount = Math.max(...columns.map(col => Object.keys(parsedData[col.field])?.length));
            tableData = Array.from({ length: rowCount }, (_, i) => {
                const row: any = {};
                columns.forEach(col => {
                    row[col.field] = parsedData[col.field][i.toString()] ?? null;
                });
                return row;
            });
            const exportColumns: any[] = columns.map((col) => ({ title: col.header, dataKey: col.field }));
            const totalRecords: number = tableData?.length
            const setRowsPerPageOptions = this.setRowsPerPageOptions(totalRecords);
            const tableObject = {
                tableData: tableData,
                columns: columns,
                exportColumns: exportColumns,
                totalRecords: totalRecords,
                setRowsPerPageOptions: setRowsPerPageOptions
            }
            return tableObject;
        } catch (error) {
            return {};
        }
    }

    setRowsPerPageOptions(totalRecords: number) {
        let rowsPerPageOptions: number[] = []
        if (totalRecords <= 50) {
            return rowsPerPageOptions = [5, 10];
        } else if (totalRecords <= 100) {
            return rowsPerPageOptions = [5, 10, 25];
        } else {
            return rowsPerPageOptions = [5, 10, 25, 50];
        }
    }

    openFeedback(feedback: boolean, queryId: number) {
        this.feedback = feedback;
        this.queryId = queryId;
        this.feedbackText = "";
        this.displayFeedback = true;
    }
    saveFeedback() {
        let feedback: IFeedbackModel = {
            sessionid: this.sessionId,
            queryId: this.queryId,
            feedback: this.feedback,
            feedbackText: this.feedbackText
        }
        this.savedSearchesService.saveFeedback(feedback)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.displayFeedback = false;
                },
                error: (error) => {
                    this.displayFeedback = false;
                }
            });
    }
    removeTypingIndicatorMessage() {
        if (this.chatMessages && this.chatMessages.length > 0) {
            let filteredArray = this.chatMessages.filter(c => c.messageType != 'typing');
            this.chatMessages = JSON.parse(JSON.stringify(filteredArray));
        }
        // this.scrollToBottom();
        // setTimeout(() => this.scrollToBottom(), 100);
    }
    getRandomRGB() {
        const r = Math.floor(Math.random() * 256); // Random red value between 0 and 255
        const g = Math.floor(Math.random() * 256); // Random green value between 0 and 255
        const b = Math.floor(Math.random() * 256); // Random blue value between 0 and 255
        return `rgb(${r},${g},${b})`;
    }
    scrollToBottom() {
        // const maxScroll = this.list?.nativeElement.scrollHeight;
        // //this.list?.nativeElement.scrollTo({top: maxScroll, behavior: 'smooth'});
        // this.list.nativeElement.scrollTo(0,maxScroll);

        try {
            this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }
    removeSpecialCharacters(strValue: string) {
        const cleanedString = strValue?.replace(/[^a-zA-Z0-9]/g, '');
        return cleanedString ?? "";
    }
    onCancelClick(): void {
        this.confirmationService.confirm({
            message: "Do you want to close?",
            header: "Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.confirmationService.close();
                this.onBodyAuto();
                this.onCancel.emit(this.chatBotInitializationData);
            },
            reject: () => { this.confirmationService.close(); this.onBodyAuto(); },
        });
    }
    toggleEmojiPicker() {
        this.showEmojiPicker = true;
    }
    addQuestion(child) {
        this.chatInputMessage = child.name;
    }
    addEmoji(e) {
        this.chatInputMessage = this.chatInputMessage + e.emoji.native;
    }
    onClick(event) {
        if (!this.container.nativeElement.contains(event.target)) // or some similar check
            this.showEmojiPicker = false;
    }

    openChart(data, type) {
        this.selectedChartData = data;
        this.displayChart = true;
        this.chartHeader = "Chart" + " - " + this.removeNumbersFromBeginning(data.query);
        this.chartData = data?.image ?? "";
        this.chartType = type;
    }
    reWrite(item) {
        this.chatInputMessage = item.message;
    }

    removeNumbersFromBeginning(text) {
        return text.replace(/^\d+\.\s*/, '');
    }

    onMaximize() {
        this.isMini = false;
        this.initialize(this.chatBotInitializationData);
        this.onBodyHidden();
    }
    onBodyAuto() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-hidden');
        body.classList.add('overflow-auto');
    }
    onBodyHidden() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-auto');
        body.classList.add('overflow-hidden');
    }

    //#region Dashboard

    savedToDashboard() {
        this.clearErrorMsg();
        this.displayNewLayout = true;
        this.getDashboardDetails();
    }



    getDashboardDetails(selectedChannelName: string = "") {
        // this.loadingDashboardDetails = true;
        this.dashboardService.getDashboardDetails().subscribe(
            {
                next: (res) => {
                    this.dashboardDetails = res || [];
                    this.formateDashboardChannels(this.dashboardDetails, selectedChannelName);
                    this.formatDashboardLayout(this.dashboardDetails);
                },
                error: (error) => {
                    this.showSpinner = false;
                }
            });
    }

    formateDashboardChannels(dashboardDetails: DashboardViewDetailsModels[], selectedChannelName: string = "") {
        this.dashboardChannels = [];
        dashboardDetails.map(dashboard => {
            const existChannel = this.dashboardChannels.find(channel => channel.name == dashboard.name);

            if (!existChannel) {
                this.dashboardChannels.push({
                    id: dashboard.id,
                    name: dashboard.name,
                    isDefault: dashboard.isDefault,
                    userId: dashboard.userId,
                    organizationId: dashboard.organizationId
                });
            }
        });

        const selectedChannel = selectedChannelName ? this.dashboardChannels.find(obj => obj?.name == selectedChannelName) || null : null;

        if (selectedChannel) {
            this.selectedDasboardChannel = selectedChannel;
        } else {
            this.selectedDasboardChannel = this.dashboardChannels.length > 0 ? this.dashboardChannels.find(obj => obj?.isDefault && obj?.userId) || this.dashboardChannels[0] : null;
        }

    }

    formatDashboardLayout(dashboardDetails: DashboardViewDetailsModels[]) {
        this.dashboardList = [];
        // this.summaryDashboardList = [];
        let dashboardLayouts: DashboardViewLayoutDetailsModels[] = [];
        dashboardDetails?.map(layouts => {
            layouts.dashBoardLayOuts?.map(layoutDetails => {
                layoutDetails.dashBoardLayOutDetails.map(obj => {
                    obj.channelName = layouts.name;
                    obj.channelId = layouts.id;
                });
                dashboardLayouts = dashboardLayouts.concat(layoutDetails.dashBoardLayOutDetails);
            })
        });

        dashboardLayouts = dashboardLayouts.sort((a, b) => (a.columnDisplayOrder - b.columnDisplayOrder));

        dashboardLayouts.map((layoutDetails, index) => {
            const today = this.app._showDateTimeWithZone(new Date());

            const addedDateRange = {};
            let havePermission = true;
            if (layoutDetails?.dashBoardContents) {
                havePermission = this.GetPermission(layoutDetails.dashBoardContents);

            }

            const widgetType: string = layoutDetails?.dashBoardContents?.dashBoardWidgetMaster?.dashBoardChartMaster?.name?.toLocaleLowerCase()?.includes('table') ? DashboardContentChartTypes.table : DashboardContentChartTypes.charts;

            const dashboardContents = (layoutDetails?.dashBoardContents && havePermission) ? {
                ...layoutDetails.dashBoardContents,
                ...addedDateRange,
                widgetType: widgetType || DashboardContentChartTypes.charts,
                reloadContent: false,
                filterOption: true,
                filterPopup: false
            } : null;

            if (!layoutDetails?.dashBoardContents || havePermission) {
                const dashboardWidget = {
                    layoutDetailsId: layoutDetails?.id || 0,
                    x: layoutDetails.xcoordinate,
                    y: layoutDetails.ycoordinate,
                    cols: layoutDetails.cols,
                    rows: layoutDetails.rows,
                    channelName: layoutDetails?.channelName || "",
                    channelId: layoutDetails.channelId || 0,
                    dashboardTempId: index + 1,
                    content: dashboardContents
                };
                this.dashboardList.push(dashboardWidget);
            }

        });
    }

    addNewDashboardLayout() {

        this.checkErrorMsg();
        if (this.selectedWidgetType == 2) {
            // this.addNewSummaryWidgetDashboardLayout();
            return;
        }

        this.selectedDasboardChannel = this.dashboardChannels.find(channel => channel.id == this.addedDashboardChannel?.id) || this.selectedDasboardChannel;
        const selectedDashboards = this.dashboardList.filter(dashboard => dashboard.channelId == this.addedDashboardChannel?.id);

        switch (this.selectedNumberOfWidgets) {
            case 1:
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 12,
                    rows: 3,
                    y: 0,
                    x: 0,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                break;
            case 2:
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 6,
                    rows: 3,
                    y: 0,
                    x: 0,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 6,
                    rows: 3,
                    y: 0,
                    x: selectedDashboards?.length > 0 ? 0 : 6,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                break;
            case 3:
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 4,
                    rows: 3,
                    y: 0,
                    x: 0,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 4,
                    rows: 3,
                    y: 0,
                    x: selectedDashboards?.length > 0 ? 0 : 4,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                this.dashboardList.push({
                    layoutDetailsId: 0,
                    cols: 4,
                    rows: 3,
                    y: 0,
                    x: selectedDashboards?.length > 0 ? 0 : 8,
                    dashboardTempId: this.getDashboardNewTempId(1),
                    channelName: this.addedDashboardChannel.name,
                    channelId: this.addedDashboardChannel.id || 0,
                    content: null
                });
                break;
            default:
                break;
        }

        const addedLayoutDetails = this.dashboardList.filter(dashboard => dashboard.channelName == this.addedDashboardChannel.name && dashboard.layoutDetailsId == 0);

        this.saveNewDashboardChannel(this.addedDashboardChannel, addedLayoutDetails);
    }

    saveNewDashboardChannel(selectedChannel: any, addedLayoutDetails: DashboardWidgetViewListModels[], showMessage: boolean = true) {

        if (selectedChannel.id == 0) {

            const channelData: DashboardAddChannelModels = {
                name: selectedChannel.name,
                statusId: 1,
                isDefault: false,
                dashBoardLayOuts: [
                    {
                        noofRow: 1,
                        statusId: 1,
                        dashBoardLayOutDetails: []
                    }
                ]
            }

            addedLayoutDetails.map(layoutDetails => {
                channelData.dashBoardLayOuts[0].dashBoardLayOutDetails.push({
                    rowDisplayOrder: 1,
                    columnDisplayOrder: 1,
                    cols: layoutDetails.cols,
                    rows: layoutDetails.rows,
                    xcoordinate: layoutDetails.x,
                    ycoordinate: layoutDetails.y,
                    statusId: 1,
                    dashBoardContents: layoutDetails?.content || null
                })
            });

            this.app.appMainService.isShowSpinner('dashboardChannelAddSavedSearch');
            this.dashboardService.addNewDashboardChannel(channelData).subscribe(response => {
                // this.getDashboardDetails(selectedChannel.name);
                // this.messageService.add({ severity: 'success', summary: 'Dashboard layout added', detail: 'Dashboard layout added successfully!' });
                // this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                const content: DashboardWidgetListModels = this.app.dashboardWidgets.find(x => x.name == 'Charts').modules.find(x => x.name == "SavedSearch").items[0];
                const widgetType: typeDashboardContentChartTypes = 'charts';
                let dashboardTempId = addedLayoutDetails?.find(x => x.layoutDetailsId == 0)?.dashboardTempId ?? 0;
                this.addDashboardContent(content, widgetType, dashboardTempId, response);
            }, (error) => {
                this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                // this.messageService.add({ severity: 'error', summary: 'Failed add dashboard layout', detail: 'Dashboard layout adding failed, please try again!' });
            })

        }

        if (selectedChannel.id > 0 && addedLayoutDetails) {

            const selectedChannelDetails = this.dashboardDetails.find(details => details.id == selectedChannel.id);

            if (selectedChannelDetails && selectedChannelDetails.dashBoardLayOuts[0].id) {

                const dashboardLayouts = selectedChannelDetails.dashBoardLayOuts[0].dashBoardLayOutDetails.sort((a, b) => (a.columnDisplayOrder - b.columnDisplayOrder));
                const lastDisplayOrder: number = dashboardLayouts.length > 0 ? (dashboardLayouts[dashboardLayouts.length - 1].columnDisplayOrder) + 1 : 1;
                const layoutData: DashboardAddLayoutModels = {
                    id: selectedChannelDetails.dashBoardLayOuts[0].id,
                    dashBoardLayOutDetails: []
                }

                addedLayoutDetails.map((layoutDetails, index) => {
                    layoutData.dashBoardLayOutDetails.push({
                        rowDisplayOrder: 1,
                        columnDisplayOrder: lastDisplayOrder + index,
                        cols: layoutDetails.cols,
                        rows: layoutDetails.rows,
                        xcoordinate: layoutDetails.x,
                        ycoordinate: layoutDetails.y,
                        statusId: 1,
                        dashBoardContents: layoutDetails?.content || null
                    })
                });

                this.app.appMainService.isShowSpinner('dashboardChannelAddSavedSearch');
                this.dashboardService.addNewDashboardLayout(layoutData).subscribe(response => {
                    // this.getDashboardDetails(selectedChannel.name);
                    // this.messageService.add({ severity: 'success', summary: 'Dashboard widgets added', detail: 'Dashboard widgets added successfully!' });
                    // this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                    const content: DashboardWidgetListModels = this.app.dashboardWidgets.find(x => x.name == 'Charts').modules.find(x => x.name == "SavedSearch").items[0];
                    const widgetType: typeDashboardContentChartTypes = 'charts';
                    let dashboardTempId = addedLayoutDetails?.find(x => x.layoutDetailsId == 0)?.dashboardTempId ?? 0;

                    this.addDashboardContent(content, widgetType, dashboardTempId, response);

                }, (error) => {
                    this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                    // this.messageService.add({ severity: 'error', summary: 'Failed add dashboard widgets', detail: 'Dashboard widgets adding failed, please try again!' });
                })
            }
        }

    }


    GetPermission(dashboardWidget: DashboardViewContentsModels) {

        const reportItems = this.reportsAllMenus.find(menu => menu.reportType == dashboardWidget.dashBoardWidgetMaster.widgetName);
        const selectedMenu = reportItems?.items?.find(item => item.reportType == dashboardWidget.dashBoardWidgetMaster.widgetCode);

        if (reportItems?.permissionName) {
            const parentPermission = this.reportPermissionData?.filter(c => c.objectName == reportItems.permissionName)[0]?.permissions?.filter(x => x.permissionName == 'Read')[0]?.statusId == 1;
            if (!parentPermission) { return false; }
        }

        if (selectedMenu && selectedMenu?.permissionName) {
            if (this.reportPermissionData != undefined && this.reportPermissionData.filter(c => c.objectName == selectedMenu?.permissionName).length > 0) {
                if (this.reportPermissionData.filter(c => c.objectName == selectedMenu?.permissionName)[0].permissions.filter(x => x.permissionName == 'Read')[0].statusId == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }

        }

        if (this.userPermissionData?.length > 0 && dashboardWidget.dashBoardWidgetMaster.widgetName == 'territory_map') {
            const territoryUserPermission = this.userPermissionData.find(obj => obj.objectName === ObjectNames.TERRITORY);
            const territoryMenuPermission = territoryUserPermission ? (territoryUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            return territoryMenuPermission;
        }

        const summaryWidgetCode = dashboardWidget?.dashBoardFilter?.find(filter => filter.filterType == DashboardAvailableFilterTypes.SummaryWidgetCode)?.filterValue || null;
        const financeSummaryWidgets = ['total_income', 'total_COGS', 'total_expense', 'accounts_receivable', 'accounts_payable'];

        if (this.userPermissionData?.length > 0 && dashboardWidget.dashBoardWidgetMaster.widgetName == 'summary_widget' && summaryWidgetCode && financeSummaryWidgets.includes(summaryWidgetCode)) {
            const financeUserPermission = this.userPermissionData.find(obj => obj.objectName === ObjectNames.FINANCE);
            const financeMenuPermission = financeUserPermission ? (financeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            return financeMenuPermission;
        }

        return true;
    }


    getDashboardNewTempId(inc: number) {
        const lastTempId = this.dashboardList[this.dashboardList.length - 1]?.dashboardTempId || 1;
        return lastTempId + inc;
    }

    addDashboardContent(content: DashboardWidgetListModels, widgetType: typeDashboardContentChartTypes, dashboardTempId: number, response: any) {
        const today = this.app._showDateTimeWithZone(new Date());
        let dateRange = getDateRange(GetDateRangeType.thisMonth, today);

        const contentDetails = {
            ...dateRange,
            widgetType: widgetType,
            reloadContent: false,
            filterOption: true,
            filterPopup: false,
            dashBoardWidgetMaster: {
                widgetTitle: content.widgetTitle,
                widgetName: content.widgetName,
                widgetCode: content.widgetCode
            }
        }

        switch (contentDetails?.dashBoardWidgetMaster?.widgetName) {
            default:
                contentDetails['addedFilters'] = {
                    dateFilter: GetDateRangeType.thisMonth
                }
                break;
        }

        const tempContentIndex = this.dashboardList.findIndex(dashboard => dashboard.dashboardTempId == dashboardTempId);

        if (tempContentIndex > -1 && this.dashboardList.length >= tempContentIndex) {
            this.dashboardList[tempContentIndex]['content'] = contentDetails;
            this.dashboardList[tempContentIndex].layoutDetailsId = response?.dashBoardLayOutDetails?.[0]?.id ?? 0;
            this.addDashboardLayoutContent(this.dashboardList[tempContentIndex], content);
            // this.app.displayDashboard = false;
        }

    }

    addDashboardLayoutContent(addedContentDetails: DashboardWidgetViewListModels, content: DashboardWidgetListModels, showMessage: boolean = true) {
        if (addedContentDetails.layoutDetailsId && content) {
            const newFiltersData: DashboardAddContentFiltersModels[] = [];
            const newFilterTemplate: DashboardAddContentFiltersModels = {
                dashboardContentId: 0,
                statusId: 1,
                filterType: 'DateFilter',
                filterValue: ""
            }

            newFiltersData.push({
                ...newFilterTemplate,
                filterType: DashboardAvailableFilterTypes.SavedSearchId,
                filterValue: this.chatBotInitializationData?.selectedSearch?.id,
            });
            newFiltersData.push({
                ...newFilterTemplate,
                filterType: DashboardAvailableFilterTypes.SavedSearchBotQuery,
                filterValue: this.selectedChartData?.query ?? '',
            });
            newFiltersData.push({
                ...newFilterTemplate,
                filterType: DashboardAvailableFilterTypes.SavedSearchChartTitle,
                filterValue: this.savedToDashboardTitle ?? 'Saved Search Chart',
            });
            const contentDetails: DashboardAddContentModels = {
                dashboardLayOutDetailId: addedContentDetails.layoutDetailsId,
                dashBoardWidgetId: content.id,
                chartTypeId: content.dashBoardChartMaster.id,
                statusId: 1,
                dashBoardContentAttributes: [
                    {
                        dashBoardContentAttributeMasterId: DashboardMasterAttributes.ChartType,
                        value: content.dashBoardChartMaster.name,
                        statusId: 1,
                    },
                    {
                        dashBoardContentAttributeMasterId: DashboardMasterAttributes.DateFilter,
                        value: GetDateRangeType.thisMonth,
                        statusId: 1,
                    },
                    {
                        dashBoardContentAttributeMasterId: DashboardMasterAttributes.FilterOption,
                        value: true,
                        statusId: 1,
                    },
                    {
                        dashBoardContentAttributeMasterId: DashboardMasterAttributes.FilterPopup,
                        value: false,
                        statusId: 1,
                    }
                ],
                dashBoardFilter: newFiltersData
            }

            // this.app.appMainService.isShowSpinner('dashboardContentAdd');
            this.dashboardService.addDashboardContent(contentDetails).subscribe(response => {
                this.getDashboardDetails(this.selectedDasboardChannel.name);
                if (showMessage) {
                    this.messageService.add({ severity: 'success', summary: 'Content added', detail: 'Content added to dashboard successfully!' });
                }
                this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                this.displayNewLayout = false;
            }, (error) => {
                this.app.appMainService.isHideSpinner('dashboardChannelAddSavedSearch');
                this.messageService.add({ severity: 'error', summary: 'Failed to add content', detail: 'Content adding failed, please try again!' });
            })

        }

    }

    clearErrorMsg() {
        this.channelSelectErrorMsg = '';
        this.savedToDashboardTitleErrorMsg = '';
    }

    checkErrorMsg() {
        this.clearErrorMsg();
        if (!this.addedDashboardChannel) {
            this.channelSelectErrorMsg = "Please select any dashboard layout.";
            return;
        }

        if (!this.savedToDashboardTitle) {
            this.savedToDashboardTitleErrorMsg = "Widget title is required.";
            return;
        }
    }

    //email
    openEmail() {
        this.displayEmail = true;
        this.sendMailLoading = false;
    }
    emailListDropdown(query: any) {
        if (this.emailListCopy?.length > 0) {
            this.emailList = this.emailListCopy.filter((c) => {
                if (!query?.trim()) {
                    return true;
                }
                return c.name?.toLowerCase().startsWith(query.toLowerCase());
            });
        }
        else {
            let objectTypeId = 1;
            let objectId = 43156;
            this.emailService.getEmailListDropdown(objectTypeId, objectId).subscribe((response: any) => {
                this.emailList = response.map(x => ({
                    id: x?.id ?? 0,
                    name: x.name,
                    emailAddress: x.emailId
                }));
                this.emailListCopy = [...this.emailList];
                if (this.emailList.length) {
                    this.emailList = this.emailListCopy.filter((c) => {
                        if (!query?.trim()) {
                            return true;
                        }
                        return c.name?.toLowerCase().startsWith(query.toLowerCase());
                    });
                }
            })
        }
    }

    onSelect(event: KeyboardEvent, recipType) {
        if (recipType === "to") {
            this.toRecipients = [...new Map(this.toRecipients.map(item => [item['emailAddress'], item])).values()];
        }
    }

    sendSavedSearchChartEmail() {
        const toMailAddress = this.toRecipients?.map(x => x.emailAddress) ?? [];
        if (toMailAddress?.length > 0) {
            let htmlBody = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
            <html xmlns="http://www.w3.org/1999/xhtml">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1" />
                <meta name="format-detection" content="telephone=yes" />
                <title></title>
            </head>

            <body>
                <img src="${this.selectedChartData?.image ?? ''}" alt="Image" />
                <br /><br />
            </body>
            </html>`;
            const mailReq: IEmailMessageRequest[] = [{
                to: toMailAddress,
                cc: [],
                bcc: [],
                subject: this.selectedChartData?.query ?? null,
                content: htmlBody,
                attachments: null,
                attachmentName: null,
                objectId: null,
                objectRecordId: null,
            }];
            this.sendMailLoading = true;
            this.sendEmailSevice.sendEmailFromSystem(mailReq).subscribe(
                {
                    next: (res) => {
                        this.messageService.add({ severity: 'success', summary: 'Send Email', detail: 'Email send successfully!' });
                        this.cancelSendMail();
                    },
                    error: (error) => {
                        this.sendMailLoading = true;
                    }
                });
        }

    }

    cancelSendMail() {
        this.sendMailLoading = false;
        this.displayEmail = false;
    }
    //#endregion

    //#region copy to clipboard
    copyMessageToClipboard(item: any): void {
        let textToCopy = '';

        // Handle different message types
        switch (item.messageType) {
            case 'text':
                textToCopy = item.message;
                break;
            case 'image':
                textToCopy = item.message || 'Image content';
                break;
            case 'table':
                textToCopy = item.message || 'Table content';
                // You could optionally format the table data as text
                break;
            default:
                textToCopy = item.message || '';
        }

        // Create a temporary textarea to copy from
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        textarea.style.position = 'fixed';  // Prevent scrolling to bottom
        document.body.appendChild(textarea);
        textarea.select();

        try {
            // Execute copy command
            const successful = document.execCommand('copy');
            if (successful) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Message copied to clipboard'
                });
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to copy message'
                });
            }
        } catch (err) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to copy message: ' + err
            });
        } finally {
            // Clean up
            document.body.removeChild(textarea);
        }
    }
    //#endregion

    //#region download file
    exportToExcel(headers: string[], data: any[], fileName: string = 'export_table_data') {
        let dataResult = [];
        data.map(rowData => {
            const obj = {};
            headers.map(header => {
                obj[header] = rowData[header] || null;
            });

            dataResult.push(obj);
        });

        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(dataResult);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFilexlsx(excelBuffer, fileName);
        });
    }

    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    //#endregion
}
